import ComingSoon from "../../../components/comingSoon/ComingSoon";

const AiTalentPoolDashboard = () => {
  return (
    <ComingSoon
      content={
        <>
          <p className="mb-4">
            Join our AI Talent Pool to showcase your <strong>"AI Readiness and Growing Potential"</strong>
          </p>
          <p className="mb-4">
            Showcase your: AI Literacy Score, AI Targeted Career, Upskilling Plan,
            Learning Progress, Completion Timeline, Mentorships Engagements, etc.
          </p>
          <p className="mb-4">
            <strong>You decide what information Employers see!</strong>
          </p>
          <p>
            Most employers are not just looking for candidates who <em>have perfect skills</em>, but those who are
            actively learning, adapting, and <strong>positioning themselves for future challenges.</strong>
          </p>
        </>
      }
    />
  );
};

export default AiTalentPoolDashboard;
